export default __webpack_public_path__ + "static/media/trezor.909f8585.svg";